import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DeleteConfiguration } from 'src/app/core/store/insight-configuration.action';
import { SnackbarService } from 'src/app/shared/components/snackbar/snackbar.service';
import { SnackbarType } from 'src/app/shared/components/snackbar/snackbar.enum';
import { IaConfigStatusBody, IaConfigStatusHeader } from 'src/app/core/enums/insightConfigurations.enum';


@Component({
  selector: 'app-delete-configuration-popup',
  templateUrl: './delete-configuration-popup.component.html',
  styleUrls: ['./delete-configuration-popup.component.scss']
})
export class DeleteConfigurationPopupComponent implements OnInit {

  public configuration: any;
  public confirm: Subject<boolean>;
  public unsubscribe = new Subject<void>();
  public disabled: boolean = false;

  constructor(
    public modalRef: BsModalRef,
    public store: Store,
    private snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.confirm = new Subject();
  }

  public onConfirmButtonClick() {
    this.disabled = true;
    
    this.store.dispatch(new DeleteConfiguration(this.configuration?.uid)).pipe(takeUntil(this.unsubscribe)).subscribe(
      () => {
        this.modalRef.hide();
        this.snackbarService.show(SnackbarType.SUCCESS, IaConfigStatusHeader.SUCCESS, IaConfigStatusBody.DELETE_SUCCESS);
        this.confirm.next(true);
      },
      () => {
        this.snackbarService.show(SnackbarType.FAILED, IaConfigStatusHeader.FAILED, IaConfigStatusBody.DELETE_FAILED);
        this.onCloseButtonClick();
      },
    )
  }
  
  public onCloseButtonClick() : void {
    this.modalRef.hide();
    this.confirm.next(false);
  }
}
